import { StyledCommonButton } from 'components/Button/styles'
import BaseModal from 'components/Modal/BaseModal'
import { ReactNode } from 'react'
import {
  HomeKebabButtonContainer,
  HomeKebabModalContainer,
  KebabModalLabel,
  KebabModalTitle,
} from '../styles'

interface HomeKebabModalProps {
  isOpen: boolean
  onClose?: () => void
  onSuccess?: () => void
  modalTitle: string
  modalLabel: string | ReactNode
}

function HomeKebabModal({
  isOpen,
  onClose,
  onSuccess,
  modalTitle,
  modalLabel,
}: HomeKebabModalProps) {
  return (
    <BaseModal isOpen={isOpen} onRequestClose={onClose}>
      <HomeKebabModalContainer>
        <KebabModalTitle>{modalTitle}</KebabModalTitle>
        <KebabModalLabel>{modalLabel}</KebabModalLabel>
      </HomeKebabModalContainer>
      <HomeKebabButtonContainer>
        <StyledCommonButton onClick={onClose}>Cancel</StyledCommonButton>
        <StyledCommonButton variant="primary" onClick={onSuccess}>
          Reboot
        </StyledCommonButton>
      </HomeKebabButtonContainer>
    </BaseModal>
  )
}

export default HomeKebabModal
